import React, { useEffect, useState } from 'react'
import MainLayout from '../Layouts/Index'
import Seo from '../Utils/Seo'
import { Box, Flex, Select, Table, TableContainer, Tbody, Text, Th, Thead, Tr, useDisclosure } from '@chakra-ui/react'
import Button from '../Components/Button'
import { DownloadTemplate, GetAllProduct, ScheduleStock, SubmitStockAPI, UploadDownloadedTemplate } from '../Utils/ApiCalls'
import StockRow from '../Components/StockRow'
import Preloader from '../Components/Preloader'
import CreateReturnToShelf from '../Components/CreateReturnToShelf'
import ColorCode from '../Components/ColorCode'
import { showToast } from '../Utils/tool'

import { local } from '../Utils/ApiConfig'
import { BiUpload } from 'react-icons/bi'

export default function TakeStock() {

    const [Shelf, setShelf] = useState("");
    const [DeActivate, setDeActivate] = useState(false);
    const [Data, setData] = useState();
    const [isLoading, setisLoading] = useState(false);
    const [SubmitLoading, setSubmitLoading] = useState(false);
    const [DownloadingTemp, setDownloadingTemp] = useState(false);
    const [UploadLoading, setUploadLoading] = useState(false);
    const [ShowUpload, setShowUpload] = useState(false);
    const [Loading, setLoading] = useState(false);
    const { isOpen, onOpen, onClose } = useDisclosure();
    const [SingleData, setSingleData] = useState();
    
    const [PayloadFile, setPayloadFile] = useState("");




    const takeStokeApi = async () => {

        try {
            setisLoading(true)
            let result = await GetAllProduct(Shelf)
            console.log("object all product", result);

            if (result.status === true) {
                setisLoading(false)
                setData(result.queryresult)
                setDeActivate(false)


            } else {
                setisLoading(false)

            }
        } catch (e) {
            setisLoading(false)

        }
    }

    const handleShelf = (e) => {
        setDeActivate(true)
        setShelf(e.target.value)
        // takeStokeApi()
        setLoading(!Loading)

    }

    const ScheduleApi = async () => {

        try {
            setisLoading(true)
            let result = await ScheduleStock(Shelf)
            console.log("ScheduleStock", result);

            if (result.status === true) {
                setisLoading(false)
                // setData(result.queryresult)
                // takeStokeApi()
                setLoading(!Loading)

            } else {
                setisLoading(false)
                // takeStokeApi()

            }
        } catch (e) {
            setisLoading(false)

        }
    }
    const SubmitStock = async () => {

        try {
            setSubmitLoading(true)
            let result = await SubmitStockAPI(Shelf)
            console.log("ScheduleStock", result);

            if (result.status === true) {
                setSubmitLoading(false)
                showToast({
                    type: 'success',
                    message: "Submitted successfully awaiting approval"
                })
                setLoading(!Loading)

            } else {
                setSubmitLoading(false)
                // takeStokeApi()

            }
        } catch (e) {
            setSubmitLoading(false)

        }
    }

    const OpenModal = (id, store, name, item) => {
        onOpen()
        setSingleData({
            id: id,
            store: store,
            name,
            item
        })
    }

    const downloadTemp = async () => {
        try {
            setDownloadingTemp(true)
            let result = await DownloadTemplate(Shelf)
            console.log("downloadTemp", result);

            if (result.status === true) {
                setDownloadingTemp(false)
                window.location = `${local}/api/v1/downloads/${result.queryresult}`;
                showToast({
                    type: 'success',
                    message: "Downloading..."
                })
                setLoading(!Loading)

            } else {
                setDownloadingTemp(false)
                // takeStokeApi()

            }
        } catch (e) {
            setDownloadingTemp(false)

        }
    }

    const handleUpload = (e)=>{
        let file = e.target.files[0]

        console.log("file",file)

        setPayloadFile(file)
    }


    const UploadDoc = async () => {

        // const formData = new FormData()

        // formData.append("file", PayloadFile)

        // console.log("formData", formData.get("file"))
        try {
            setUploadLoading(true)
            let result = await UploadDownloadedTemplate(PayloadFile)
            console.log("UploadDownloadedTemplate", result);

            if (result.status === true) {
                setUploadLoading(false)
                takeStokeApi()
                showToast({
                    type: 'success',
                    message: "Uploaded Successfully"
                })


            } else {
                setUploadLoading(false)
                // takeStokeApi()

            }
        } catch (e) {
            setUploadLoading(false)

        }
    }

    useEffect(() => {
        takeStokeApi()
    }, [isOpen, Loading]);

    return (
        <MainLayout>
            <Seo title='Take Stock' description='IMS Take Stock' />
            <Box rounded="8px" bg="#ddd" h="auto" px="1%" py="10px">
                <Flex flexWrap={"wrap"} justifyContent={"space-between"}>
                    <Box w={["100%", "100%", "100%", "32%", "32%",]}>
                        <Text fontWeight={"500"} pb="5px"> Select Store</Text>
                        <Select borderColor={"#000"} color={"#000"} placeholder='Select Store' _focus={{ borderColor: "blue.blue400" }} fontWeight={"400"} fontSize={Shelf != "" ? "16px" : "12px"} id='store' value={Shelf} onChange={handleShelf}>

                            <option value="1" >Admin Store Marina</option>
                            <option value="2" >Central Circle stores, Ijora</option>
                            <option value="3" >East Circle stores, Island</option>
                            <option value="4" >West Circle stores, Festac</option>

                        </Select>

                    </Box>
                    <Flex w={["100%", "100%", "100%", "32%", "32%",]} position={"relative"} bottom={"-7"} >
                        {
                            Data?.length > 0 ? (
                                <Button onClick={ScheduleApi} disabled={true} isLoading={isLoading}>Take Stock</Button>

                            ) : (
                                <Button onClick={ScheduleApi} disabled={Shelf === "" ? true : false} isLoading={isLoading}>Take Stock</Button>

                            )
                        }
                    </Flex>


                    <Flex w={["100%", "100%", "100%", "32%", "32%",]} mt={["10px", "10px", "10px", "0px", "0"]} position={"relative"} bottom={"-7"} >

                        <Button onClick={SubmitStock} disabled={Data?.length > 0 ? false : true} isLoading={SubmitLoading}>Submit</Button>
                    </Flex>

                </Flex>

                {/* <Button mt={"20px"} isLoading={Loading} disabled={Report.typeof !== "" && Report.fromDate !== "" && Report.toDate !== "" && Report.store !== "" ? false : true} onClick={GetReport}>Get Report</Button> */}
            </Box>


            <Flex mt='20px' justifyContent={"space-between"}>
                <Button w="auto" mt="12px" isLoading={DownloadingTemp} onClick={downloadTemp}>Download template </Button>
                <Button w="auto" mt="12px" onClick={() => setShowUpload(!ShowUpload)} >  <BiUpload /> </Button>

            </Flex>

            {
                ShowUpload && (
                    <Box mt="12px">
                        <input type='file' onChange={handleUpload}/>
                        <Button w="auto" mt="12px" isLoading={UploadLoading} onClick={UploadDoc}>Upload Document</Button>

                    </Box>
                )
            }


            <Box display={"block"} alignItems="flex-start" w={"100%"} height="70vh" minH={"70vh"} overflow="auto" _hover={{ overflow: "auto" }} bg="blue.blue200" mt="32px" rounded={"8px"}>
                <ColorCode />
                <TableContainer w={"100%"} mt="32px" overflowX="auto" color="#fff"

                >
                    <Table variant='simple' size='sm' overflowX="auto" >
                        <Thead>
                            <Tr>
                                <Th color="#fff">S/N</Th>
                                <Th color="#fff">Product name</Th>
                                <Th color="#fff">Counted QTY group</Th>
                                <Th color="#fff">Store</Th>
                                <Th color="#fff">Action</Th>



                            </Tr>
                        </Thead>
                        <Tbody>

                            {
                                Data?.map((item, i) => (
                                    <StockRow
                                        type="typeStock"
                                        key={i}
                                        sn={i + 1}
                                        productName={item.productname}
                                        qty={item.countedqty || 0}
                                        serviceable={item.countedqtyserviceable || 0}
                                        unServiceable={item.countedqtyunserviceable || 0}
                                        store={Shelf}
                                        index={item}
                                        TakeData={Data}
                                        onClick={() => OpenModal(item._id, Shelf, item.productname, item)}
                                    />
                                ))
                            }
                        </Tbody>

                    </Table>
                </TableContainer>

            </Box>

            <CreateReturnToShelf state="takeStock" sendingId={SingleData} isOpen={isOpen} onClose={onClose} />

        </MainLayout>
    )
}
